import PouchDB from "pouchdb";
PouchDB.plugin(require("pouchdb-find"));

export default class DB {
  constructor() {
    this.db = new PouchDB("rtLogistic", { size: 50 });
  }

  getAll() {
    return new Promise((resolve, reject) => {
      this.db
        .allDocs({ include_docs: true })
        .then((result) => {
          resolve(result.rows);
        })
        .catch((err) => reject(err));
    });
  }

  createLoad(load) {
    return new Promise(async (resolve, reject) => {
      const existeLoad = await this.db.get(`${load.id}`).catch((err) => { });
      if (existeLoad) {
        await this.removeById(`${load.id}`);
      }
      await this.db.put(load).catch((err) => reject(err));
      const object = { id: `${load.id}` };
      resolve(object);
    });
  }

  findByIdAndUpdate(load_id, Newload) {
    return new Promise(async (resolve, reject) => {
      let res = await this.db.get(load_id).catch((err) => { });
      if (res) {
        Newload._id = res._id;
        Newload._rev = res._rev;
        Newload.orden = res.orden;
        await this.db.put(Newload).catch((err) => reject(err));
        const object = { load_id: load_id };
        resolve(object);
      } else {
        let orden = parseInt(localStorage.getItem("orden"));
        orden = orden + 1;
        Newload._id = Newload.load_id;
        Newload.orden = orden;
        localStorage.setItem("orden", orden);
        await this.db.put(Newload).catch((err) => reject(err));
        const object = { load_id: load_id };
        resolve(object);
      }
    });
  }

  async geByLoadId(load_id) {

    await this.db.get(load_id).catch((err) => { });
  }

  removeById(load_id) {
    return new Promise(async (resolve, reject) => {
      const doc = await this.db.get(load_id).catch((err) => reject(err));
      await this.db.remove(doc).catch((err) => { });
      const object = { id: `${load_id}` };
      resolve(object);
    });
  }

  deleteAll() {
    return new Promise((resolve) => {
      this.db.allDocs({ include_docs: true }).then((result) => {
        return Promise.all(
          result.rows.map((row) => {
            return this.db.remove(row.id, row.value.rev);
          })
        ).then(() => {
          resolve(true);
        });
      });
    });
  }
}
